module.exports = __webpack_public_path__ + "img/security-logos.b56167c8.png";